// ===== SLIDER DRAG & DROP - NOS SALONS =====
(function() {
  'use strict';
  
  const sliderWrapper = document.querySelector('.prestations-slider-wrapper');
  const slider = document.querySelector('.prestations-slider');
  const slides = document.querySelectorAll('.slide');
  const prevBtn = document.querySelector('.slider-nav.prev');
  const nextBtn = document.querySelector('.slider-nav.next');
  
  if (!sliderWrapper || !slider || slides.length === 0) return;
  
  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let previousTranslate = 0;
  let currentIndex = 0;
  let animationID;
  
  // Calculer la largeur d'une slide
  const slideWidth = slides[0].offsetWidth;
  const totalSlides = slides.length;
  
  // Extraire la valeur actuelle de transform
  const getCurrentTranslate = () => {
    const transform = slider.style.transform;
    if (transform) {
      const match = transform.match(/translateX\((-?\d+(?:\.\d+)?)px\)/);
      return match ? parseFloat(match[1]) : 0;
    }
    return 0;
  };
  
  // Initialiser avec la valeur existante
  currentTranslate = getCurrentTranslate();
  previousTranslate = currentTranslate;
  
  // ===== DRAG EVENTS =====
  
  // Mouse events
  sliderWrapper.addEventListener('mousedown', dragStart);
  sliderWrapper.addEventListener('mouseup', dragEnd);
  sliderWrapper.addEventListener('mouseleave', dragEnd);
  sliderWrapper.addEventListener('mousemove', drag);
  
  // Touch events (mobile)
  sliderWrapper.addEventListener('touchstart', dragStart);
  sliderWrapper.addEventListener('touchend', dragEnd);
  sliderWrapper.addEventListener('touchmove', drag);
  
  function dragStart(e) {
    // Ne pas drag si on clique sur un lien ou bouton
    if (e.target.closest('a') || e.target.closest('button.slide-button')) {
      return;
    }
    
    isDragging = true;
    startX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    sliderWrapper.classList.add('dragging');
    slider.classList.add('dragging');
    
    // Annuler l'animation
    cancelAnimationFrame(animationID);
  }
  
  function drag(e) {
    if (!isDragging) return;
    
    e.preventDefault();
    const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    const diff = currentX - startX;
    
    currentTranslate = previousTranslate + diff;
    
    // Limiter le drag aux limites du slider
    const maxTranslate = 0;
    const minTranslate = -(slideWidth * (totalSlides - 1));
    
    if (currentTranslate > maxTranslate) {
      currentTranslate = maxTranslate;
    }
    if (currentTranslate < minTranslate) {
      currentTranslate = minTranslate;
    }
    
    slider.style.transform = `translateX(${currentTranslate}px)`;
  }
  
  function dragEnd() {
    if (!isDragging) return;
    
    isDragging = false;
    sliderWrapper.classList.remove('dragging');
    slider.classList.remove('dragging');
    
    const movedBy = currentTranslate - previousTranslate;
    
    // Si on a bougé de plus de 100px, changer de slide
    if (movedBy < -100 && currentIndex < totalSlides - 1) {
      currentIndex++;
    }
    if (movedBy > 100 && currentIndex > 0) {
      currentIndex--;
    }
    
    setPositionByIndex();
    previousTranslate = currentTranslate;
  }
  
  function setPositionByIndex() {
    currentTranslate = currentIndex * -slideWidth;
    slider.style.transition = 'transform 0.3s ease';
    slider.style.transform = `translateX(${currentTranslate}px)`;
    
    setTimeout(() => {
      slider.style.transition = '';
    }, 300);
    
    updateButtons();
  }
  
  function updateButtons() {
    if (prevBtn && nextBtn) {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === totalSlides - 1;
      
      prevBtn.style.opacity = currentIndex === 0 ? '0.3' : '1';
      nextBtn.style.opacity = currentIndex === totalSlides - 1 ? '0.3' : '1';
    }
  }
  
  // ===== NAVIGATION BUTTONS =====
  
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        setPositionByIndex();
        previousTranslate = currentTranslate;
      }
    });
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (currentIndex < totalSlides - 1) {
        currentIndex++;
        setPositionByIndex();
        previousTranslate = currentTranslate;
      }
    });
  }
  
  // Initialiser les boutons
  updateButtons();
  
  // ===== RESPONSIVE =====
  
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newSlideWidth = slides[0].offsetWidth;
      currentTranslate = currentIndex * -newSlideWidth;
      previousTranslate = currentTranslate;
      slider.style.transform = `translateX(${currentTranslate}px)`;
    }, 250);
  });
  
})();